
export class BiMessageIdRequest {
    biMessageId: number;
    username: string;

    /**
     * 
     * @param biMessageId 
     * @param username 
     */
    constructor(biMessageId: number, username: string) {
        this.biMessageId = biMessageId;
        this.username = username;
    }
}
